// extracted by mini-css-extract-plugin
module.exports = {"benefits":"Benefits_benefits__zt0aJ","back":"Benefits_back__2h-oH"};